<template>
  <div class="foreign-info-collection">
    <!-- 主要表单内容 -->
    <div
      class="form-container"
    >
      <!-- 提示信息 -->
      <div class="tip-section">
        <span class="tip-icon">i</span>
        <span class="tip-text">为了履行纳税义务，现按照税法规定收集信息，不做其他使用</span>
      </div>

      <!-- 表单 -->
      <van-form
        ref="form"
        @submit="onSubmit"
      >
        <!-- 证件上传 -->
        <div class="form-item">
          <div class="label-required">
            <span class="label-text">证件</span>
            <span class="required-mark">*</span>
          </div>
          <div class="upload-box">
            <!-- 未上传状态 -->
            <div
              v-if="uploadedImages.length === 0"
              class="upload-placeholder"
              @click="handleUploadClick"
            >
              <van-icon
                name="photograph"
                class="upload-icon"
              />
              <div class="upload-hint">
                点击或拖拽上传证件照片
              </div>
              <div class="upload-format">
                支持JPG、PNG格式，支持上传多张
              </div>
            </div>
            <!-- 已上传状态 -->
            <div
              v-else
              class="upload-preview"
            >
              <div
                v-for="(image, index) in uploadedImages"
                :key="index"
                class="preview-item"
              >
                <img
                  :src="image"
                  alt="证件照片"
                  @click="showImagePreview(image)"
                />
                <div
                  class="delete-btn"
                  @click.stop="deleteImage(index)"
                >
                  删除
                </div>
              </div>
              <!-- 新增图片按钮 -->
              <div
                class="add-image-btn"
                @click="handleUploadClick"
              >
                <van-icon name="plus" />
              </div>
            </div>
          </div>
        </div>

        <!-- 姓名 -->
        <div class="form-item">
          <div class="label-required">
            <span class="label-text">姓名</span>
            <span class="required-mark">*</span>
          </div>
          <van-field
            v-model="contractData.name"
            placeholder="请输入姓名"
            readonly
            disabled
            :rules="[{ required: true, message: '姓名为必填项' }]"
          />
          <div class="field-tip">
            取自系统，不可修改
          </div>
        </div>

        <!-- 证件号码 -->
        <div class="form-item">
          <div class="label-required">
            <span class="label-text">证件号码</span>
            <span class="required-mark">*</span>
          </div>
          <van-field
            v-model="contractData.cardNo"
            placeholder="请输入证件号码"
            readonly
            disabled
            :rules="[{ required: true, message: '证件号码为必填项' }]"
          />
          <div class="field-tip">
            取自系统，不可修改
          </div>
        </div>

        <!-- 手机号码 -->
        <div class="form-item">
          <div class="label-required">
            <span class="label-text">手机号码</span>
            <span class="required-mark">*</span>
          </div>
          <van-field
            v-model="contractData.mobile"
            placeholder="请输入手机号码"
            readonly
            disabled
            :rules="[{ required: true, message: '手机号码为必填项' }]"
          />
          <div class="field-tip">
            取自系统，不可修改
          </div>
        </div>

        <!-- 证件类型 -->
        <div class="form-item">
          <div class="label-required">
            <span class="label-text">证件类型</span>
            <span class="required-mark">*</span>
          </div>
          <van-field
            v-model="contractData.cardType"
            placeholder="请选择证件类型"
            readonly
            disabled
            :rules="[{ required: true, message: '证件类型为必填项' }]"
          />
          <div class="field-tip">
            取自系统，不可修改
          </div>
        </div>

        <!-- 国籍 -->
        <div class="form-item">
          <div class="label-required">
            <span class="label-text">国籍</span>
            <span class="required-mark">*</span>
          </div>
          <van-field
            v-model="formData.country"
            placeholder="请输入国籍"
            :rules="[{ required: true, message: '国籍为必填项' }]"
          />
        </div>

        <!-- 出生日期 -->
        <div class="form-item">
          <div class="label-required">
            <span class="label-text">出生日期</span>
            <span class="required-mark">*</span>
          </div>
          <van-field
            v-model="formData.birthday"
            placeholder="年/月/日"
            readonly
            is-link
            :rules="[{ required: true, message: '出生日期为必填项' }]"
            @click="showDatePicker = true"
          />
        </div>

        <!-- 出生国家 -->
        <div class="form-item">
          <div class="label-required">
            <span class="label-text">出生国家</span>
            <span class="required-mark">*</span>
          </div>
          <van-field
            v-model="formData.birthCountry"
            placeholder="请输入出生国家"
            :rules="[{ required: true, message: '出生国家为必填项' }]"
          />
        </div>

        <!-- 性别 -->
        <div class="form-item">
          <div class="label-required">
            <span class="label-text">性别</span>
            <span class="required-mark">*</span>
          </div>
          <van-field
            v-model="genderText"
            placeholder="请选择性别"
            readonly
            is-link
            :rules="[{ required: true, message: '性别为必填项' }]"
            @click="showGenderPicker = true"
          />
        </div>

        <!-- 操作按钮 -->
        <div class="button-section">
          <van-button
            block
            class="btn-cancel"
            :disabled="submitting"
            native-type="button"
            @click="onCancel"
          >
            取消
          </van-button>

          <van-button
            block
            type="primary"
            native-type="submit"
            :loading="submitting"
            :disabled="submitting"
            class="btn-submit"
          >
            提交
          </van-button>
        </div>
      </van-form>

      <!-- 日期选择器 -->
      <van-popup
        v-model="showDatePicker"
        position="bottom"
      >
        <van-datetime-picker
          v-model="selectedDate"
          type="date"
          title="选择出生日期"
          :min-date="minDate"
          :max-date="maxDate"
          @confirm="onDateConfirm"
          @cancel="showDatePicker = false"
        />
      </van-popup>

      <!-- 性别选择器 -->
      <van-popup
        v-model="showGenderPicker"
        position="bottom"
      >
        <van-picker
          title="选择性别"
          :columns="genderOptions"
          show-toolbar
          @confirm="onGenderConfirm"
          @cancel="showGenderPicker = false"
        />
      </van-popup>
    </div>

    <!-- 图片预览弹窗 -->
    <van-popup
      v-model="showImagePreviewDialog"
      :style="{ background: 'transparent' }"
      @close="showImagePreviewDialog = false"
    >
      <div class="image-preview-popup">
        <div class="preview-header">
          <van-icon
            name="close"
            class="close-icon"
            @click="showImagePreviewDialog = false"
          />
        </div>
        <div class="preview-content">
          <img
            :src="currentPreviewImage"
            alt="预览图片"
          />
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {
  Field, Form, Popup, DatetimePicker, Picker, Button, Dialog, Icon, Toast,
} from 'vant';
import 'vant/lib/field/style';
import 'vant/lib/form/style';
import 'vant/lib/popup/style';
import 'vant/lib/datetime-picker/style';
import 'vant/lib/picker/style';
import 'vant/lib/button/style';
import 'vant/lib/dialog/style';
import 'vant/lib/icon/style';
import dayjs from 'dayjs';
import createWalletApi from '@/api/createWallet';
import billApi from '@/api/bill';
import { chooseImage } from '@/util/knb';

export default {
  name: 'ForeignInfoCollection',
  components: {
    [Field.name]: Field,
    [Form.name]: Form,
    [Popup.name]: Popup,
    [DatetimePicker.name]: DatetimePicker,
    [Picker.name]: Picker,
    [Button.name]: Button,
    [Dialog.Component.name]: Dialog.Component,
    [Icon.name]: Icon,
  },
  props: {
    contractData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      formData: {
        name: '',
        cardNo: '',
        mobile: '',
        cardType: '',
        cardTypeCode: null,
        country: '',
        birthday: '',
        birthCountry: '',
        gender: null,
      },
      uploadedImages: [],
      showDatePicker: false,
      showGenderPicker: false,
      submitting: false,
      showImagePreviewDialog: false,
      currentPreviewImage: '',
      genderOptions: [
        { text: '男', value: 1 },
        { text: '女', value: 0 },
      ],
      minDate: new Date(1900, 0, 1),
      maxDate: new Date(),
      selectedDate: new Date(2000, 0, 1),
    };
  },
  computed: {
    genderText() {
      if (this.formData.gender === null) return '';
      return this.formData.gender === 1 ? '男' : '女';
    },
  },
  created() {
  },
  methods: {
    // eslint-disable-next-line complexity
    async handleUploadClick() {
      try {
        const imageList = await chooseImage();

        // 用户取消选择，不显示错误提示
        if (!imageList || imageList.length === 0) return;

        // eslint-disable-next-line no-restricted-syntax
        for (const imageFile of imageList) {
          // 验证文件大小
          if (imageFile.size >= 7 * 1024 * 1024) {
            throw new Error('选择的图片不能超过7M');
          }

          try {
            // eslint-disable-next-line no-await-in-loop
            const res = await createWalletApi.uploadImage(imageFile);
            const url = res && res.data && res.data.url;
            if (!url) throw new Error('上传照片失败');

            this.uploadedImages.push(url);
          } catch (error) {
            console.error('Upload error:', error);
            throw new Error('上传失败，请重试');
          }
        }
      } catch (e) {
        Toast.fail(e.message || '操作失败');
      }
    },

    deleteImage(index) {
      this.uploadedImages.splice(index, 1);
    },

    onDateConfirm(value) {
      this.formData.birthday = dayjs(value).format('YYYY/MM/DD');
      this.showDatePicker = false;
    },

    onGenderConfirm(value) {
      this.formData.gender = value.value;
      this.showGenderPicker = false;
    },


    // eslint-disable-next-line complexity
    async onSubmit() {
      // 表单校验
      // 1. 验证证件上传
      if (this.uploadedImages.length === 0) {
        Toast.fail('请上传证件图片');
        return;
      }

      // 6. 验证国籍
      if (!this.formData.country || this.formData.country.trim() === '') {
        Toast.fail('国籍为必填项');
        return;
      }

      // 7. 验证出生日期
      if (!this.formData.birthday || this.formData.birthday.trim() === '') {
        Toast.fail('出生日期为必填项');
        return;
      }

      // 8. 验证出生国家
      if (!this.formData.birthCountry || this.formData.birthCountry.trim() === '') {
        Toast.fail('出生国家为必填项');
        return;
      }

      // 9. 验证性别
      if (this.formData.gender === null || this.formData.gender === undefined) {
        Toast.fail('性别为必填项');
        return;
      }

      this.submitting = true;

      // 填充自动带出的数据
      if (this.contractData.needCollect) {
        this.formData.name = this.contractData.name || '';
        this.formData.cardNo = this.contractData.cardNo || '';
        this.formData.mobile = this.contractData.mobile || '';
        this.formData.cardType = this.contractData.cardType || '';
        this.formData.cardTypeCode = this.contractData.cardTypeCode || null;
      }

      try {
        const submitData = {
          ...this.formData,
          imageUrl: this.uploadedImages.join(','),
          birthday: this.formData.birthday.replace(/\//g, '-'), // 转换为YYYY-MM-DD格式
        };

        // 调用报税信息收集接口
        const response = await billApi.collectTaxDeclareInfo(submitData);

        if (response && response.code === 0) {
          Toast.success('提交成功');
          this.$emit('submit-success');
        } else {
          Toast.fail(response?.message || '提交失败');
        }
      } catch (error) {
        console.error('Submit error:', error);
        Toast.fail('提交失败');
      } finally {
        this.submitting = false;
      }
    },

    onCancel() {
      this.$emit('cancel');
    },

    showImagePreview(imageUrl) {
      this.currentPreviewImage = imageUrl;
      this.showImagePreviewDialog = true;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/theme';

.foreign-info-collection {
  min-height: 100vh;
  background: #f7f8fa;
  .form-container {
    padding: 16px;

    .tip-section {
      display: flex;
      align-items: flex-start;
      padding: 12px 16px;
      margin-bottom: 24px;
      background: #f5f5f5;
      border-left: 3px solid $mt_yellow;
      border-radius: 4px;

      .tip-icon {
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 20px;
        height: 20px;
        margin-right: 8px;
        background: $mt_yellow;
        color: #fff;
        border-radius: 50%;
        font-size: 12px;
        font-weight: 600;
      }

.tip-text {
         flex: 1;
         font-size: 24px;
         color: #333;
         line-height: 24px;
         text-align: left;
       }
    }

    .form-item {
      margin-bottom: 24px;
      .label-required {
        display: flex;
        align-items: center;
        margin-bottom: 8px;

        .label-text {
          font-size: 30px;
           color: #333;
           font-weight: 500;
         }

        .required-mark {
          color: red;
          margin-left: 4px;
        }
      }

      .upload-box {
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 160px;
        margin-bottom: 8px;
        background: #fff;
        border: 2px dashed #ddd;
        border-radius: 8px;
        cursor: pointer;
        transition: all 0.3s;

        &:active {
          border-color: $mt_yellow;
          background: #fffbf0;
        }

        .upload-placeholder {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

.upload-hint {
             font-size: 18px;
             color: #999;
             margin-bottom: 4px;
           }

.upload-format {
             font-size: 16px;
             color: #ccc;
           }
        }

        .upload-icon {
          font-size: 32px;
          color: #ddd;
          margin-bottom: 8px;
        }

        .upload-preview {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));
          gap: 8px;
          width: 100%;
          padding: 8px;

          .preview-item {
            position: relative;
            width: 80px;
            height: 80px;
            border-radius: 4px;
            overflow: hidden;

            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }

.delete-btn {
               position: absolute;
               bottom: 0;
               left: 0;
               right: 0;
               background: rgba(0, 0, 0, 0.6);
               color: #fff;
               font-size: 16px;
               padding: 4px;
               text-align: center;
               cursor: pointer;
             }
          }
        }
      }

.field-tip {
         font-size: 16px;
         color: #999;
         margin-top: 4px;
         text-align: left;
       }
    }

    .button-section {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 12px;
      margin-top: 32px;
      padding-bottom: 32px;

      .btn-cancel {
        background: #fff;
        color: #333;
        border: 1px solid #ddd;
      }

      .btn-submit {
        background: $mt_yellow;
        border-color: $mt_yellow;
        color: #333;
      }
    }
  }

  // 调大 van-field 组件内的文字
  /deep/ .van-field__value {
    font-size: 30px;
  }

  /deep/ .van-field__control {
    font-size: 30px;
  }

  /deep/ .van-field__input {
    font-size: 30px;
  }

  .dialog-content {
    padding: 20px 16px;
    font-size: 14px;
    line-height: 20px;
    color: #666;
  }
}
</style>
